/***
 * Created on 2024/1/8
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/

import React, {useEffect, useState} from 'react';
import {apiGet} from "../../service/api";
import SetupTwostepWarning from "./setup_twostep_warning";
import Password_warning from "./password_warning";
import PasswordWarning from "./password_warning";
import sharedI18n from "common/SharedI18n";
import {I18nextProvider} from "react-i18next";
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false, // default: true
        },
    },
});


function UserWarning(props) {
    const [showTSWarning, setShowTSWarning] = useState(false);
    const [showPSWarning, setShowPSWarning] = useState(false);
    const checkAlive = async () => {
        apiGet('/alive').then(resp => {
            if (!resp.alive) {
                location.href = '/'
            }
            else {
                getWarningParam();
            }
        })
    }

    const getWarningParam = () => {
        const url = new URL(location.href);
        if (url.searchParams.has('pw')) {
            setShowPSWarning(url.searchParams.get('pw') === 'true');
        }
        else if (url.searchParams.has('ts')) {
            setShowTSWarning(url.searchParams.get('ts') === 'true')
        }
    }

    useEffect(() => {
        checkAlive();
        // getWarningParam();
    }, [])

    return (
        <I18nextProvider i18n={sharedI18n} >
            <QueryClientProvider client={queryClient}>
                <div>
                    {showTSWarning && <SetupTwostepWarning showModal={showTSWarning} />}
                    {showPSWarning && <PasswordWarning showModal={showPSWarning} />}
                </div>
            </QueryClientProvider>
        </I18nextProvider>
    );
}

export default UserWarning;